import { MultipleOfferCard } from 'app/components/multiple-offer-card';

export function BottomMultipleOfferCard({ showTopMultipleOfferCard }: { showTopMultipleOfferCard: boolean }) {
  return showTopMultipleOfferCard ? null : <MultipleOfferCard />;
}
